export { default as RegulationModal } from './RegulationModal';
